import Configuration from './Configuration'

/**
 * Class for tracking widget events in Google Tag Manager
 */
class TagManager {
  /**
   * @var {Object} brandsLabel Map between brand notation and labels
   */
  brandsLabel = {
    P: 'Peugeot',
    C: 'Citroen',
    DS: 'DS'
  }

  /**
   * constructor
   */
  constructor() {
    // Create dataLayer if it not exists
    window.dataLayer = window.dataLayer || [];
  }

  /**
   * Send a tag event
   * 
   * @param {String} virtualPageURL
   * @param {String} pageCategory
   * @param {String} formsLeadType
   * @param {String} formsName
   * @param {String} mainStepIndicator
   * @param {String} mainStepName
   * @param {String} vehicleModelBodystyle
   * @param {String} vehicleModelBodystyleLabel
   */
  sendEvent(
    virtualPageURL,
    pageCategory ,
    formsLeadType ,
    formsName ,
    mainStepIndicator ,
    mainStepName ,
    vehicleModelBodystyle ,
    vehicleModelBodystyleLabel
  ) {
    // Create event from parameters
    const event = {
      virtualPageURL,
      pageCategory ,
      formsLeadType ,
      formsName ,
      mainStepIndicator ,
      mainStepName ,
      vehicleModelBodystyle ,
      vehicleModelBodystyleLabel
    }

    // Add common event data
    event.event =          'updatevirtualpath'
    event.brand =          this.brandsLabel[Configuration.brand]
    event.language =       Configuration.language
    event.country =        Configuration.country
    event.siteTypeLevel1 = 'kpp'
    event.siteTypeLevel2 = 'form::consommationUsage'
    event.siteOwner =      'local'
    event.siteTarget =     'ALL'
    event.siteFamily =     'brand'

    // Build and add page name
    const pageName = [
      event.siteTypeLevel1,
      event.siteTypeLevel2,
      event.siteOwner,
      event.siteTarget,
      event.siteFamily,
      '',
      'desktop'
    ]
    .join('/')

    event.pageName = `${pageName}//>${document.title}`

    // Remove null/undefined event properties from the dataLayer and push it
    window.dataLayer.push( Object.keys(event).reduce((acc, key) => {
      if (event[key] !== null && event[key] !== undefined) {
        acc[key] = event[key]
      }

      return acc
    }, {}))
  }
}

export default new TagManager()


// WEBPACK FOOTER //
// ./src/TagManager.js